/**
 * Rule that checks gateway conditions and default paths
 */

const { is } = require("bpmnlint-utils");

function getWF() {
  const w = typeof window !== "undefined" ? window : null;
  const inst = w && w.getSdInstance ? w.getSdInstance() : null;
  const prov = inst && inst.workflowProvider;
  const wf1 = prov && prov.getSelectedWf ? prov.getSelectedWf() : null;
  const wf2 = w && w.__wfSelected ? w.__wfSelected : null;
  return wf1 || wf2 || null;
}

function hasCompleteCondition(cond) {
  if (!cond || typeof cond !== "object") return false;

  if (cond.field1 && cond.conditionOperator) return true;

  const set = cond.conditionSet;
  if (!set || !Array.isArray(set.conditions) || set.conditions.length === 0) return false;

  return true;
}

module.exports = function gatewayConditions() {
  // console.log('[rule] loaded gateway-conditions');
  return {
    check(node, reporter) {
      if (!node) return;
      // console.log('[rule] gateway-conditions check', node && node.id, node && node.$type);

      const isExclusive = is(node, "bpmn:ExclusiveGateway");
      const isInclusive = is(node, "bpmn:InclusiveGateway");
      if (!isExclusive && !isInclusive) return;

      const flows = Array.isArray(node.outgoing) ? node.outgoing : [];

      // Converging gateways (joins) have a single outgoing flow that doesn't
      // represent a branch decision — it's just the continuation of the
      // merged flow. Conditions are only meaningful on diverging (forking)
      // gateways with ≥2 outgoing paths. Skip join gateways entirely.
      if (flows.length < 2) return;

      if (isExclusive && !node.default) {
        reporter.report(node.id, "Exclusive Gateways should have a default path.");
      }

      const wf = getWF();
      const decisions = wf && wf.nodes && Array.isArray(wf.nodes.decisions) ? wf.nodes.decisions : [];

      for (const flow of flows) {
        const decision = decisions.find((s) => s && s.id === flow.id);

        // BPMN xml is the canonical source of truth for defaults. If the
        // gateway has a `default` property pointing at a SPECIFIC flow, only
        // THAT flow is default; JSON's stale isDefault flags on other flows
        // are ignored. Fall back to JSON isDefault only when no BPMN default
        // is set at all.
        let isDefault;
        if (node.default) {
          isDefault = node.default.id === flow.id;
        } else {
          isDefault = decision && decision.isDefault === true;
        }

        if (isDefault) continue;

        // Non-default path: must have a complete condition.
        // Missing decision entry entirely = no condition was ever assigned.
        const cond = decision ? decision.condition || {} : null;
        const ok = cond && hasCompleteCondition(cond);
        if (!ok) {
          if (isExclusive) {
            reporter.report(flow.id, "Exclusive Gateway paths should have a complete condition.");
          } else if (isInclusive) {
            reporter.report(flow.id, "Inclusive Gateway paths should have a complete condition.");
          }
        }
      }
    }
  };
};
